import { NgModule } from '@angular/core';
import { SafeHtmlPipe } from 'src/pipes/safe-html.pipe';

@NgModule({
  declarations: [
    SafeHtmlPipe
  ],
  exports: [
    SafeHtmlPipe
  ],
 
})
export class SafeHtmlModule {
}
